import { cn } from '@/lib/utils';

interface CreditNovaLogoProps {
  variant?: 'mark' | 'full';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  scale?: number; // Added scale prop
}

const sizes = {
  sm: 'h-10 w-10', // Sidebar size
  md: 'h-12 w-12',
  lg: 'h-16 w-16',
  xl: 'h-24 w-24',
};

export function CreditNovaLogoNoLetters({
  variant = 'full',
  size = 'md',
  className,
  scale,
}: CreditNovaLogoProps) {
  // Determine scale using provided scale, or default to 1.5 for marks to fill the space
  const finalScale = scale || (variant === 'mark' ? 1 : .8);

  return (
    <div className={cn('relative flex items-center justify-center overflow-hidden', sizes[size], className)}>
      <img
        src="/CN_logo_updated_NO_Letters.png"
        alt="CreditNova"
        style={{ transform: `scale(${finalScale})` }}
        className="h-full w-full object-contain transition-all duration-300 group-hover:scale-110"
      />
    </div>
  );
}